import React, { useState, useEffect } from "react";

import { CgAdd } from "react-icons/cg";
import { MdDelete } from "react-icons/md";
import { baseUrl } from "../../../../Environments/environment";
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import { toast } from "react-toastify";
import { apiClient } from "../../../../api";

function TemplateForm() {
	const { selectedPropertyId } = useProperty();
	const [templates, setTemplates] = useState([]);
	const [customTemplates, setCustomTemplates] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const handleTextChange = (index) => (e) => {
		const newTemplates = [...templates];
		if (e.target.value.replace(/[^a-zA-Z]/g, "").length <= 200) {
			newTemplates[index].message = e.target.value;
		}
		setTemplates(newTemplates);
	};

	const handleAddTemplate = () => {
		setCustomTemplates([
			...customTemplates,
			{ name: "", message: "", type: "Custom" },
		]);
	};

	const handleDeleteTemplate = (index) => {
		const newTemplates = [...customTemplates];
		newTemplates.splice(index, 1);
		setCustomTemplates(newTemplates);
	};

	const handleCustomTemplateChange = (index, field) => (e) => {
		const newTemplates = [...customTemplates];
		newTemplates[index][field] = e.target.value;
		setCustomTemplates(newTemplates);
	};

	useEffect(() => {
		getTemplates();
		// eslint-disable-next-line
	}, []);

	const getTemplates = async () => {
		try {
			const response = await apiClient.get(
				`${baseUrl}/messageTemplate/${selectedPropertyId}`,
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			setTemplates(response.data.result.reverse());
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	const handleSubmit = async () => {
		// console.log(customTemplates);
		let finalTemplates = templates.concat(customTemplates);

		try {
			setIsLoading(true);
			const response = await apiClient.put(
				`${baseUrl}/messageTemplate/${selectedPropertyId}`,
				finalTemplates,
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			toast.success(response.data.message);
			setIsLoading(false);
			getTemplates();
			setCustomTemplates([]); // Fetch templates again after saving
		} catch (error) {
			console.log(error);
			const errorMessage =
				error.response?.data?.message ||
				"Failed to update templates. Please try again.";
			toast.error(errorMessage);
			setIsLoading(false);
		}
	};

	return (
		<div className="bg-gray-100 p-12">
			<div className="flex items-center justify-between mb-4 sticky top-0 bg-gray-100 z-20 py-3">
				<h2 className="text-2xl font-semibold">Templates</h2>

				<div className="flex">
					<button
						onClick={handleAddTemplate}
						className="bg-[#4F46E5] hover:bg-indigo-500 text-white font-medium px-2 py-1.5 rounded-md focus:outline-none m-2 w-44 flex items-center"
					>
						<CgAdd className="mr-1.5 text-[18px]" />
						New Template
					</button>

					<button
						onClick={handleSubmit}
						className="bg-green-400 hover:bg-green-500 text-white font-medium px-2 py-1.5 rounded-md m-2 w-40"
					>
						{isLoading ? "Saving..." : "Save Changes"}
					</button>
				</div>
			</div>
			{/* Custom Templates */}
			<div className="bg-gray-200 mt-4 border border-gray-200 rounded-lg">
				{customTemplates.map((template, index) => (
					<div key={index} className="mb-1 px-8 py-4">
						<div className="flex items-center -mb-3">
							<select
								value="Custom"
								className="block w-full max-w-[15vw] text-sm rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 mr-4"
								disabled
							>
								<option value="Custom">Custom</option>
							</select>

							<input
								type="text"
								value={template.name}
								onChange={handleCustomTemplateChange(index, "name")}
								className="block w-full max-w-[15vw] rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-400 placeholder:text-sm"
								placeholder="Name the template"
							/>
							<button
								onClick={() => handleDeleteTemplate(index)}
								className="bg-gray-200 font-semibold px-4 py-2 rounded-md ml-4"
							>
								<MdDelete className="text-[#FB7185] text-[30px]" />
							</button>
						</div>
						<div className="relative">
							<div className="text-right text-sm text-gray-500">
								{template.message.replace(/[^a-zA-Z]/g, "").length} / 200
							</div>
							<textarea
								value={template.message}
								onChange={handleCustomTemplateChange(index, "message")}
								className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 resize-none overflow-y-auto"
								rows="6"
							/>
						</div>
					</div>
				))}
			</div>
			{/* Templates Section */}
			<div className="relative mx-auto px-8 py-4 bg-white border border-gray-50 rounded-lg overflow-auto mt-4">
				{templates.map((template, index) => (
					<div key={index} className="mb-5">
						<div className="-mb-3">
							<select
								value={template.name}
								className="block w-full max-w-[15vw] text-sm rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500"
							>
								<option value={template.name}>{template.name}</option>
							</select>
						</div>
						<div className="relative">
							<div className="text-right text-sm text-gray-500">
								{template.message.replace(/[^a-zA-Z]/g, "").length} / 200
							</div>
							<textarea
								disabled={template.type === "Default"}
								value={template.message}
								onChange={handleTextChange(index)}
								className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 resize-none overflow-y-auto"
								rows="6"
							/>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

export default TemplateForm;
